/** What can happen to an intervento, in the order of its life. */
export const eventTypes = [
    'creato',
    'avviato',
    'completato',
    'riparazione_avviata',
    'riparazione_completata',
    'riparazione_annullata',
    'correzione',
];
